import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { roomTypeFormDefault } from "@factory/form/form.default";
import { RoomTypeFormRule, RoomTypeFormSchema } from "@factory/form/form.rule";
import { useQyCreateRoomType } from "@factory/query/room-type.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewRoomType() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateRoomType } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New RoomType is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addRoomType, isLoading: isCreating } =
    useQyCreateRoomType(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<RoomTypeFormSchema>({
    defaultValues: roomTypeFormDefault,
    resolver: zodResolver(RoomTypeFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: RoomTypeFormSchema) => {
    const formData = mapCreateRoomType(form);
    addRoomType(formData);
  };
  const handleValidateError = (err: FieldErrors<RoomTypeFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
